import { useEffect, useState } from "react"

import { App, Flex, Modal, Spin, Typography } from "antd"
import { t } from "i18next"
import { useDispatch, useSelector } from "react-redux"

import Icon from "../../../../../Icon"
import {
  addOutsiderPayoutMethod,
  getOutsiderPayoutMethod,
  updateOutsiderPayoutMethod
} from "../../../redux/referrals.thunks"
import PaymentMethodForm from "./PaymentMethodForm"

import "./PaymentMethodFormModal.less"

const { Text } = Typography

const PaymentMethodFormModal = ({ open, close, type }) => {
  const dispatch = useDispatch()
  const { notification } = App.useApp()
  const [isValidForm, setIsValidForm] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { outsiderPayoutMethod, outsiderPayoutMethodFetching } = useSelector(
    (state) => state.referrals
  )
  const isMobile = useSelector((state) => state.nav.isMobile)

  useEffect(() => {
    if (open) {
      dispatch(getOutsiderPayoutMethod())
    }
  }, [open])

  const onSubmit = (values) => {
    setIsSubmitting(true)

    const save =
      type === "add" ? addOutsiderPayoutMethod : type === "edit" ? updateOutsiderPayoutMethod : null
    if (!save) return

    dispatch(save(values))
      .unwrap()
      .then(() => {
        close()
        setIsSubmitting(false)
      })
      .catch((data) => {
        setIsSubmitting(false)
        notification.error({
          message: data?.message?.detail || "An error occurred while saving the payment method.",
          closeIcon: <Text>{t("Dismiss")}</Text>
        })
      })
  }

  return (
    <Modal
      open={open}
      onClose={close}
      onCancel={close}
      onOk={close}
      title={
        <Flex vertical gap={8}>
          <Text className="title">Payment details</Text>
          <Text type="secondary" strong>
            View and manage your payment methods for withdrawals
          </Text>
        </Flex>
      }
      closeIcon={<Icon type="cross_small" />}
      cancelText="Cancel"
      okText="Save"
      okButtonProps={{
        size: "large",
        form: "payment-method-form",
        htmlType: "submit",
        disabled: !isValidForm,
        loading: isSubmitting,
        onClick: (e) => e.stopPropagation()
      }}
      cancelButtonProps={{
        size: "large"
      }}
      rootClassName="payment-method-form-modal clear-bg"
      classNames={{
        content: "clear-bg"
      }}
      width={isMobile ? "100%" : 442}
      centered={!isMobile}
      wrapClassName={isMobile ? "payment-method-form-modal--mobile" : ""}
      getContainer={isMobile ? document.body : () => document.getElementById("global-wrap")}
      destroyOnClose
    >
      {outsiderPayoutMethodFetching ? (
        <Flex align="center" justify="center">
          <Spin />
        </Flex>
      ) : (
        <PaymentMethodForm
          initialValues={outsiderPayoutMethod}
          onSubmit={onSubmit}
          setIsValidForm={setIsValidForm}
        />
      )}
    </Modal>
  )
}

export default PaymentMethodFormModal
